import saveAs from "file-saver";
import { DataDRequest } from "../DRequest";
import { Global } from "../Global";

export async function _SvArchivoPlantillaAlumnosObtenerExcel(): Promise<boolean> {
    const url = Global._GLOBAL_CONF.URL_SrvRoot + "archivo/importar/plantilla/ObtenerExcel?IdEscuela=0&IdCategoria=20";
    const filename = "Alumnos.xlsx";

    return DataDRequest._XMLHttpRequestFile(url, filename)
        .then(file => {
            saveAs(file)
            return true
        })
        .catch(() => false)
}

export async function _SvArchivoPlantillaTutoresObtenerExcel() {
    const url = Global._GLOBAL_CONF.URL_SrvRoot + "archivo/importar/plantilla/ObtenerExcel?IdEscuela=0&IdCategoria=22";
    const filename = "Tutores.xlsx";

    return DataDRequest._XMLHttpRequestFile(url, filename)
        .then(file => {
            saveAs(file);
            return true;
        })
        .catch(() => false);
}

export async function _SvArchivoPlantillaGruposObtenerExcel(): Promise<boolean> {
    const url = Global._GLOBAL_CONF.URL_SrvRoot + "archivo/importar/plantilla/ObtenerExcel?IdEscuela=0&IdCategoria=21";
    const filename = "Grupos.xlsx";

    return DataDRequest._XMLHttpRequestFile(url, filename)
        .then(file => {
            saveAs(file);
            return true;
        })
        .catch(() => false);
}

export async function _SvArchivoPlantillaLogrosObtenerExcel(): Promise<boolean> {
    const url = Global._GLOBAL_CONF.URL_SrvRoot + "archivo/importar/plantilla/ObtenerExcel?IdEscuela=0&IdCategoria=7";
    const filename = "Logros.xlsx";

    return DataDRequest._XMLHttpRequestFile(url, filename)
        .then(file => {
            saveAs(file);
            return true;
        })
        .catch(() => false);
}
